import {
  CarrierListDto,
  PatchCarrierDto,
  PostCarrierDto,
} from "mock-api/src/shared-v2-types";
import { getApiDetailsDecorator } from "src/utils";

const api = getApiDetailsDecorator<
  CarrierListDto | PatchCarrierDto | PostCarrierDto
>();

export abstract class BaseCarrier {
  protected constructor(args: ClassProperties<BaseCarrier>) {
    this.key = args.key;
    this.name = args.name;
  }

  @api({ key: "carrierKey" }) public readonly key: string;
  @api() public readonly name: string;
}
